import React, { useState } from "react";
import { detailsSms } from "../../../services/EmailTypeService";
import "../../../components/EmailModal/Modal.css";
import { getConsultantsAndManagers } from "../../../services/UserService";
import { getUserData } from "../../../utils/FunctionHelpers";
import {
  CircularProgress,
  Button,
  TextField,
  Fade,
  Backdrop,
  Modal,
} from '@mui/material';
import { Autocomplete } from "@mui/material";
import { BiMessage } from "react-icons/bi";
import { FiSend } from "react-icons/fi";
import { withSnackbar } from "../../../utils/SnackbarHOC";
import { sendSmsToCandidat } from "../../../services/CandidatService";
const SmsCandidat = ({ candidatTel, candidatFullName, candidatFirstName, snackbarShowMessage, candidatId, ...props }) => {
  const [errors, setErrors] = useState({});
  const [options, setOptions] = useState([]);
  const [optionsUser, setOptionsUser] = useState([]);
  const [open, setOpen] = useState(false);
  const [openUser, setOpenUser] = useState(false);
  const [de, setDe] = useState(getUserData().uuid);
  const [Messages, setMessages] = useState("");
  const [message, Setmessage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [messageCounter, setMessageCounter] = useState(160 - message.length);
  const [userName, setUserName] = useState(`${getUserData()?.lastname} ${getUserData()?.firstname}`);

  const validate = () => {
    let temp = {};
    temp.de = de ? "" : "Le champ 'De' est obligatoire.";
    temp.message = message ? "" : "Le champ 'Message' est obligatoire.";
    setErrors({
      ...temp,
    });
    return Object.values(temp).every((x) => x === "");
  };

  React.useEffect(() => {
    if (openModal) {
      setLoading(true);
      (async () => {
        try {
          const emailTypes = await detailsSms(1);
          const activeUsers = await getConsultantsAndManagers();
          setOptionsUser(activeUsers.data.managers);
          setOptions(emailTypes.data.emailType);
        } catch (err) {
          snackbarShowMessage("Erreur de chargement des données", "error");
        } finally {
          setLoading(false);
        }
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal]);

  const handleChangeMessageType = (value) => {
    const replacements = [
      ["[Prenom_CDT]", candidatFirstName],
      ["Prenom_CDT", candidatFirstName],
      ["[Nom_Account_Manager]", userName],
      ["[Prenom_Nom_CDT]", candidatFullName],
      ["[Prenom_Consultant]", userName.split(" ")[0]],
    ];

    const msgTxt = value || "-";
    const updatedMsgTxt = replacements.reduce((txt, [search, replacement]) => {
      const formattedReplacement = replacement.charAt(0).toUpperCase() + replacement.slice(1);
      return txt.replace(search, formattedReplacement);
    }, msgTxt);

    handleMessage(updatedMsgTxt);
  }

  const handleSend = async () => {
    if (validate()) {
      try {
        setLoading(true)
        const payload = {
          candidatId,
          consultantId: de,
          content: message
        }
        await sendSmsToCandidat(payload);
        snackbarShowMessage(`SMS a été envoyé à ${candidatFullName} avec succès !`);
        props.setLoadData(!props.loadData);
        handleCloseModal();
      } catch {
        snackbarShowMessage("Erreur d'envoi du SMS", "error");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleCloseModal = () => {
    if (!loading) {
      setOpenModal(false);
    }
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleMessage = (value) => {
    if (value.length > 160) {
      Setmessage(value.slice(0, 160))
      setMessageCounter(160 - value.slice(0, 160).length)
    } else {
      Setmessage(value)
      setMessageCounter(160 - value.length)
    }
  }

  const body = (
    <>
      <div className="modalBackground">
        <div className="modalContainer ">
          <div>
            <div>
              <label className="input-label" htmlFor="A">
                À : {candidatFullName} {"<" + candidatTel + ">"}
              </label>
            </div>
            <div>
              <label className="input-label" htmlFor="messages">
                De <span className="required-input">*</span>
              </label>
              <Autocomplete
                open={openUser}
                onOpen={() => setOpenUser(true)}
                onClose={() => setOpenUser(false)}
                getOptionSelected={(option, value) =>
                  option.uuid === value.uuid
                }
                getOptionLabel={(option) => option.user}
                onChange={(event, values) => {
                  setDe(values.uuid);
                  setUserName(values.user);
                  handleChangeMessageType(Messages.message)
                }}
                options={optionsUser}
                loading={loading}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    placeholder={`${getUserData()?.lastname} ${getUserData()?.firstname}`}
                    {...(errors.users && {
                      error: true,
                      label: errors.users,
                    })} slotProps={{ ...params.slotProps, input: { ...params.slotProps?.input, ...({
                      ...params.slotProps.input,
                      endAdornment: (
                        <React.Fragment>
                          {loading ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.slotProps.input?.endAdornment}
                        </React.Fragment>
                      ),
                    }) } }}
                  />
                )}
              />
            </div>
            <div>
              <label className="input-label" htmlFor="messages">
                Message Type
              </label>
              <Autocomplete
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                getOptionSelected={(option, value) =>
                  option.msgName === value.msgName
                }
                getOptionLabel={(option) => option.msgName}
                onChange={(event, values) => {
                  setMessages(values);
                  handleChangeMessageType(values.message)
                }}
                options={options}
                loading={loading}
                disableClearable
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={Messages ? Messages.msgName : ""}
                    placeholder={Messages ? Messages.msgName : ""}
                    {...(errors.Messages && {
                      error: true,
                      label: errors.Messages,
                    })} slotProps={{ ...params.slotProps, input: { ...params.slotProps?.input, ...({
                      ...params.slotProps.input,
                      endAdornment: (
                        <React.Fragment>
                          {loading ? (
                            <CircularProgress color="inherit" size={20} />
                          ) : null}
                          {params.slotProps.input?.endAdornment}
                        </React.Fragment>
                      ),
                    }) } }}
                  />
                )}
              />
            </div>
            <div>
              <label className="input-label" htmlFor="message">
                Message <span className="required-input"> *</span>
              </label>
              <TextField
                multiline
                minRows={6}
                id="message"
                value={message}
                onChange={(e) => handleMessage(e.target.value)}
                placeholder="message..."
                margin="normal"
                variant="outlined"
                autoComplete="off"
                fullWidth
                {...(errors.message && {
                  error: true,
                  label: errors.message,
                })} slotProps={{ htmlInput: { maxLength: 160 } }}
              />
              {messageCounter}
            </div>
          </div>
          <div className="footer" style={{ float: "right", padding: "20px 0px 0px 0px" }}>
            <Button
              sx={{ background: '#f1f5f9', color: '#475569', border: '1px solid #e2e8f0', borderRadius: '10px', textTransform: 'none', fontWeight: 600, mr: 1, '&:hover': { background: '#e2e8f0' } }}
              onClick={handleCloseModal}
              disabled={loading}
            >
              Annuler
            </Button>
            <Button
              startIcon={<FiSend />}
              sx={{ background: 'linear-gradient(135deg, #0556a4, #03407b)', color: '#fff', borderRadius: '10px', textTransform: 'none', fontWeight: 600, boxShadow: '0 2px 8px rgba(3,64,123,0.28)', '&:hover': { background: 'linear-gradient(135deg, #03407b, #022d68)' } }}
              disabled={loading}
              onClick={handleSend}
            >
              Envoyer
            </Button>
          </div>
        </div>
      </div>
    </>
  );

  return (
    <>
      <Button
        startIcon={<BiMessage color="117aa7" />}
        data-toggle="tooltip"
        title="SMS"
        onClick={handleOpenModal}
      />
      <Modal
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
        open={openModal}
        onClose={handleCloseModal}
      >
        <Fade in={openModal}>{body}</Fade>
      </Modal>
    </>
  );
};

export default withSnackbar(SmsCandidat);
